<template >
    <div v-touch:swipe="swipeHandler" class="row content">
      <vue-topprogress ref="topProgressBar" :trickle="false" color="#85C33F" :height="5"></vue-topprogress>
      <div v-show="!this.$isMobile() && !$store.state.config.isConfigMode" @mouseenter="displayOnMouseEvent('back')" @mouseleave="displayOnMouseEvent('back')" :class="'col-md-1 backButton'">
          <BackButton :class="(!this.$isMobile() &&  $store.state.form.orderedLayouts[$store.state.form.orderedLayouts.indexOf($store.state.form.currentLayout) - 1] && showPreviousButton) ? '' : 'd-none'"/>
        </div>
        <div class="col-md-4 leftSide" :style="'background-image: url('+(($store.state.config.mainconfig.background) ? $store.state.config.mainconfig.background : 'https://sales.deciplus.pro/static/img/DefaultTemplate/background.jpg') + ')'">
          <div class="row" style="height: 60px;">
          </div>
          <div class="row">
            <div class="mx-auto col-md-10">
              <img :src="($store.state.config.mainconfig.logo) ? $store.state.config.mainconfig.logo : 'https://sales.deciplus.pro/static/img/DefaultTemplate/logo.png'" alt="Logo" class="logo" />
            </div>
          </div>
          <div class="row usernameLoggedIn">
            <div class="mx-auto col-md-6">
              <form id="advisor">
                <span v-show="$store.getters['user/isAuthenticated']">{{$t('form.coach')}}:</span>
                <select v-model="advisor" class="form-control filledForm" @change=changeAdvisor() style="text-align: center;">
                  <option v-for="(advisor, index) in advisors" :value="advisor" :key="index">{{advisor.name}}</option>
                </select>
              </form>
            </div>
          </div>
        </div>
        <!--Dynamic layout here-->
        <div class="col-md-4"></div>
        <div class="col-md-8">
            <keep-alive v-if="$store.state.form.alive">
              <div v-if="!$store.state.config.isConfigMode" class="mx-auto col-md-10" v-bind:is="$store.state.form.currentLayout"></div>
              <div v-else class="mx-auto col-md-10" v-bind:is="'Configuration'"></div>
            </keep-alive>
          <footer v-show="!$store.state.config.isConfigMode" @mouseenter="displayOnMouseEvent('footer')" @mouseleave="displayOnMouseEvent('footer')">
            <span v-show="showFooter" v-for="i in $store.state.form.orderedLayouts.length" :key="i" @click="goToStep(i)" :class="'dot ' + (($store.getters['form/currentIndexStep'] === i) ? 'bg-color' : '')"></span>
          </footer>
        </div>
        <div v-show="!this.$isMobile() && !$store.state.config.isConfigMode" @mouseenter="displayOnMouseEvent('next')" @mouseleave="displayOnMouseEvent('next')" class="col-md-1 nextButton">
          <NextButton :class="(!this.$isMobile() && this.$store.getters['form/isNextLayout'] && showNextButton) ? '' : 'd-none'"/>
        </div>
        <i class="fas fa-sync-alt reset" @click="$store.dispatch('form/FORM_RESET', true)"></i>
        <i class="fas fa-cog config" @click="$store.dispatch('config/CONFIG_TOGGLECONFIGMODE')"></i>
      </div>
</template>
<script>
import Configuration from '@/layouts/config/Configuration';
import KnowUs from '@/layouts/KnowUs';
import CustomerDatas from '@/layouts/CustomerDatas';
import Target from '@/layouts/Target';
import TargetWeightloss from '@/layouts/TargetWeightloss';
import TargetFitness from '@/layouts/TargetFitness';
import TargetZen from '@/layouts/TargetZen';
import TargetBodybuilding from '@/layouts/TargetBodybuilding';
import HowManyTimes from '@/layouts/HowManyTimes';
import WhatLevel from '@/layouts/WhatLevel';
import ChoiceCriteria from '@/layouts/ChoiceCriteria';
import FinalCustomerDatas from '@/layouts/FinalCustomerDatas';
import StarterPack from '@/layouts/StarterPack';
import Offers from '@/layouts/Offers';
import Options from '@/layouts/Options';
import EndStep from '@/layouts/EndStep';
import NextButton from '@/components/NextButton';
import BackButton from '@/components/BackButton';
var JSZip = require('jszip');
export default {
  name: 'Form',
  components: {
    Configuration,
    KnowUs,
    CustomerDatas,
    Target,
    TargetWeightloss,
    TargetFitness,
    TargetZen,
    TargetBodybuilding,
    HowManyTimes,
    WhatLevel,
    ChoiceCriteria,
    FinalCustomerDatas,
    StarterPack,
    Offers,
    Options,
    EndStep,
    NextButton,
    BackButton
  },
  data () {
    return {
      baseurl: '/www/clients/' + document.location.host + '/moduleVente/',
      coach: this.$store.user,
      showNextButton: false,
      showPreviousButton: false,
      showFooter: false,
      advisors: [],
      advisor: {}
    };
  },
  beforeMount: function () {
    this.$http.interceptors.response.use((response) => { // intercept the global error
      return response;
    }, function (error) {
      if (!error.response) {
        // network error
      } else {
        if (error.response.status === 401) { // token expired ... redirect to login
          // window.location.href = 'login.php';
        }
      }
      return Promise.reject(error);
    });
  },
  mounted: function () {
    if (!this.$store.getters['user/isAuthenticated']) {
      location.href = 'login.php';
    } else {
      this.getAllUsers();
    }
  },
  updated: function () {
    if (!this.$store.state.form.alive) {
      this.$store.dispatch('form/FORM_ENABLEFORM');
    }
  },
  methods: {
    download: function () {
      let zip = new JSZip();
      for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).indexOf('.json') !== -1) {
          zip.file(localStorage.key(i), localStorage.getItem(localStorage.key(i)));
        }
      }
      if (Object.keys(zip.files).length !== 0) {
        zip.generateAsync({type: 'base64'}).then(function (base64) {
          location.href = 'data:application/zip;base64,' + base64;
        });
      }
    },
    displayOnMouseEvent: function (button) {
      switch (button) {
        case 'next':
          this.showNextButton = !this.showNextButton;
          break;
        case 'back':
          this.showPreviousButton = !this.showPreviousButton;
          break;
        case 'footer':
          this.showFooter = !this.showFooter;
          break;
      }
    },
    swipeHandler (direction) {
      switch (direction) {
        case 'right':
          if (this.$store.state.form.orderedLayouts[this.$store.state.form.orderedLayouts.indexOf(this.$store.state.form.currentLayout) - 1]) {
            this.$store.dispatch('form/FORM_PREVIOUSLAYOUT');
          }
          break;
        case 'left':
          if (this.$store.getters['user/isAuthenticated'] && this.$store.getters['config/isConfigOk'] && this.$store.getters['form/isNextLayout']) {
            this.$store.dispatch('form/FORM_NEXTLAYOUT', this.$store.state.form.dataToSave);
          }
          break;
      }
    },
    goToStep: function (index) {
      if (this.$store.getters['user/isAuthenticated'] && this.$store.getters['config/isConfigOk']) {
        this.$store.dispatch('form/FORM_SETLAYOUT', {index: index - 1, data: this.$store.state.form.dataToSave});
      }
    },
    findWithAttr: function (array, attr, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    getAllUsers: function () {
      this.$http.get('user')
        .then((resp) => {
          if (resp.data.errno !== undefined) {
            this.$notify({ type: 'error', title: this.$t('general.errorApi.generalTitle'), text: resp.data.errormsg });
          }
          this.advisors = resp.data.response;
          this.advisor = this.advisors[this.findWithAttr(this.advisors, 'id', this.$store.state.user.id)];
          this.$store.dispatch('form/FORM_CHANGEADVISOR', this.advisor);
          // eslint-disable-next-line
        }).catch((err) => {
          this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('general.errorApi.listUsers.errormsg')});
          this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'getAllUsers');
        });
    },
    changeAdvisor: function () {
      this.$store.dispatch('form/FORM_CHANGEADVISOR', this.advisor);
    }
  },
  computed: {
    configMode: function () {
      return this.$store.state.config.isConfigMode;
    }
  },
  watch: {
    configMode: function (configEnable, oldVal) {
      if (!configEnable) { // Si on sort du mode configuration, on fait un call api pour sauvegarder la configuration actuelle en bdd
        this.$store.dispatch('config/CONFIG_UPLOADCONFIG', this.$store.state.user.token).then((resp) => {
          if (resp.data.errno !== undefined) {
            this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: resp.data.errormsg});
          } else {
            this.$notify({
              type: 'success',
              title: this.$t('config.saveNotif.title'),
              text: this.$t('config.saveNotif.message')
            });
          }
          // eslint-disable-next-line
        }).catch((err) => {
          this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('general.errorApi.setConfig.errormsg')});
          this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'configMode');
        });
      }
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content {
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/Form.vue